// extracted by mini-css-extract-plugin
export var accordion_header = "product-module--accordion_header--c5c3b";
export var description_title = "product-module--description_title--a023d";
export var description_title2 = "product-module--description_title2--6c5ef";
export var description_title3 = "product-module--description_title3--791bd";
export var disabled_link = "product-module--disabled_link--2dbe4";
export var light_text = "product-module--light_text--37d37";
export var page_title = "product-module--page_title--e772a";